import { render, staticRenderFns } from "./carousel-drawer.vue?vue&type=template&id=497bde8b&scoped=true&"
import script from "./carousel-drawer.vue?vue&type=script&lang=js&"
export * from "./carousel-drawer.vue?vue&type=script&lang=js&"
import style0 from "./carousel-drawer.vue?vue&type=style&index=0&id=497bde8b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497bde8b",
  null
  
)

export default component.exports